import { LigneCommande } from './ligne-commande.model';

export class EnteteCommande {
  dateValidation: string;
  codeKNE: string;
  mailLivraison: string;
  montantTotal: number;
  montantFraisDePort: number;
  numeroCommandeSiteTier: string;
  nomEtablissement: string;
  villeEtablissement: string;
  prenomAcheteur: string;
  nomAcheteur: string;
  villeLivraison: string;
  ligneCommande: LigneCommande;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/entete-commande.model.ts